import Sms from './sms'

function ThreeWaveSending() {
    return {
        topTaster: 'Deliver better, not sooner.',
        name: 'Optimised Delivery',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/threeWave.png',
        content:
            'By sending your campaign in intelligently timed waves, this option helps you avoid triggering spam filters and ensures your message lands safely in more inboxes.'
    }
}

function TimeBasedSending() {
    return {
        topTaster: 'Send smarter, not just faster.',
        name: 'Best Engagement',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/timeBased.png',
        content:
            'We’ll analyse past contact behaviour and automatically send your emails when each person is most likely to open and click – no guesswork required.'
    }
}

function GatedContent() {
    return {
        topTaster: 'Unlock exclusive content.',
        name: 'Gated Content',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/gated-content.png',
        content:
            'Create forms that require users to provide their email address before accessing premium content, helping you grow your contact list while delivering value.'
    }
}

function Conversations() {
    return {
        topTaster: 'Engage your audience in real-time.',
        name: 'Conversations',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/chat_1.png',
        content:
            'Conversations unifies live chat and email so that you can respond to incoming enquiries better and faster than ever before, and turn leads into loyal customers.'
    }
}

function SocialChannels() {
    // send social campaigns to multiple channels
    return {
        topTaster: 'Expand your reach, amplify your impact.',
        name: 'multiple social channels',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/social-campaigns-upsell.png',
        content:
            'Social Campaigns let you create, schedule, and publish posts across multiple channels. Helping you engage your audience, drive more traffic, and grow your brand beyond your inbox.'
    }
}

function AbSplit() {
    return {
        topTaster: 'Test, learn, and optimise.',
        name: 'A/B Split Tests',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/ab-split-test.png',
        content:
            'A/B Split Tests let you test different versions of your campaigns to see what works best. Helping you improve engagement, conversions, and ROI.'
    }
}

function FacebookMessenger() {
    return {
        topTaster: 'Add Facebook Messenger messages to your combined inbox.',
        name: 'Facebook Messenger',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/facebook-messenger-upsell.png',
        content:
            'Connect your Facebook Messenger account to manage and respond to messages directly from your combined inbox, streamlining your communication and improving response times.'
    }
}

function customTemplateBlocks() {
    return {
        topTaster: 'Save and reuse your favourite layouts.',
        name: 'Saved Layouts',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/ab-split-test.png',
        content:
            'Save your favourite template blocks and layouts to easily access and reuse them in future campaigns, streamlining your design process and maintaining brand consistency.'
    }
}

function TrackingDomains() {
    return {
        topTaster: 'Make all your emails look like they come from the same place.',
        name: 'Tracking Subdomains',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/tracking-domains.png',
        content:
            'Add tracking subdomains to your email campaigns to make all your emails look like they come from the same place. Helping you improve your deliverability and engagement.'
    }
}

function CDNDomains() {
    return {
        topTaster: 'Make all your emails look like they come from the same place.',
        name: 'CDN Subdomains',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/tracking-domains.png',
        content:
            'Add CDN domains to your email campaigns to make all your emails look like they come from the same place. Helping you improve your deliverability and engagement.'
    }
}

function Mcp() {
    return {
        topTaster: 'Connect AI assistants to your Transpond account.',
        name: 'MCP',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/mcp.png',
        content:
            'Use Transpond MCP to let AI assistants look up contacts, campaigns, automations, and more — so you can manage your marketing without leaving the tools you already use.'
    }
}

function LandingPages() {
    return {
        topTaster: 'Publish more landing pages.',
        name: 'Landing Pages',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/landingPageCTA.png',
        content:
            'Upgrade your plan to publish more live landing pages and turn more visitors into contacts with focused, conversion-ready pages.'
    }
}

function LandingPageCustomDomains() {
    return {
        topTaster: 'Publish landing pages on your own domain.',
        name: 'Landing Page Custom Domains',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/landingPageCTA.png',
        content:
            'Upgrade to Growth to host landing pages on your authenticated custom domains for a fully branded visitor experience.'
    }
}

function SocialAccounts() {
    return {
        topTaster: 'Connect more than one account.',
        name: 'multiple social accounts',
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/social-campaigns-upsell.png',
        content:
            'Upgrade to connect additional Facebook, LinkedIn, Instagram, or X accounts. Reach more audiences from the same Transpond account without switching integrations.'
    }
}

export default function getFeature(feature, account, onUpgrade, props) {
    if (feature === 'threeWaveSending') {
        return ThreeWaveSending()
    } else if (feature === 'timeBasedSending') {
        return TimeBasedSending()
    } else if (feature === 'gatedContent') {
        return GatedContent()
    } else if (feature === 'inboxes') {
        return Conversations()
    } else if (feature === 'socialChannels') {
        return SocialChannels()
    } else if (feature === 'abSplit') {
        return AbSplit()
    } else if (feature === 'sms') {
        return Sms(account, props.plans, onUpgrade)
    } else if (feature === 'facebookInboxChannel') {
        return FacebookMessenger()
    } else if (feature === 'customTemplateBlocks') {
        return customTemplateBlocks()
    } else if (feature === 'trackingDomains') {
        return TrackingDomains()
    } else if (feature === 'cdnDomains') {
        return CDNDomains()
    } else if (feature === 'mcp') {
        return Mcp()
    } else if (feature === 'landingPages') {
        return LandingPages()
    } else if (feature === 'landingPageCustomDomains') {
        return LandingPageCustomDomains()
    } else if (feature === 'socialAccounts') {
        return SocialAccounts()
    }
    return null
}
